import React from 'react'

export default function Techno 
() {
  return (
    <div  >
        <div className='font-bold text-3xl text-center '>My Skills</div>
        <div className='m-2 flex flex-wrap gap-3 items-center justify-center p-4 '>
            <div className='bg-white p-1 w-24 font-bold text-center  ' >HTML</div>
            <div className='bg-white p-1 w-24 font-bold text-center ' >CSS</div>
            <div className='bg-white p-1 w-24 font-bold text-center '>Reactjs</div>
            <div className='bg-white p-1 w-24 font-bold text-center ' >Express js</div>
            <div className='bg-white p-1 w-24 font-bold text-center ' >Nodejs</div>
            <div className='bg-white p-1 w-24 font-bold text-center ' >javascript</div>
            <div className='bg-white p-1 w-24 font-bold text-center ' >C++</div>
        </div>
    </div>
  )
}
